import { render, staticRenderFns } from "./uf_support_prog_id.vue?vue&type=template&id=a4fca5b8&scoped=true"
import script from "./uf_support_prog_id.vue?vue&type=script&lang=js"
export * from "./uf_support_prog_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fca5b8",
  null
  
)

export default component.exports